<div class="banner-slider-wrap overlay-slider-elem" dir="ltr">
   <div class="banner-slider"> 
      <app-banner-slider [bannerSliderContent]="bannerContent" [bannerSliderConfig]="bannerConfig"></app-banner-slider>
   </div>
</div>
<!-- banner-slider-wrap close -->
